// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"755":"ac6b5ad7","838":"d1ab719d"}[chunkId] + ".js";
};